export const playSound = async (
  url: string,
  volume: number = 0.5,
): Promise<void> => {
  const audio = new Audio(url);
  audio.volume = volume;
  await audio.play();
};

export const playSoundMute = async (url: string): Promise<void> => {
  const audio = new Audio(url);
  audio.muted = true;
  await audio.play();
};
